<div class="container container-margin">
	<div class="row">
		<div class="col-12">
			<h3><strong>Campaign Criteria</strong></h3>
		</div>
	</div>
	<hr />

	<div class="row">
		<div class="col-12">
			<span style="margin-right: 40px"><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="LMS" />All prospects from same source</span>
			<span style="margin-right: 40px"><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="CLIENT" /> Client List</span>
			<span><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="BOTH" /> Both</span>

			<div *ngIf="criterias.prospects_from === 'LMS'" class="alert alert-info mt-3" style="font-weight: 800">This campaign is getting records from LMS Database</div>

			<div *ngIf="criterias.prospects_from === 'CLIENT'" class="alert alert-info mt-3" style="font-weight: 800">This campaign is getting records from a client List</div>
			<div *ngIf="criterias.prospects_from === 'BOTH'" class="alert alert-info mt-3" style="font-weight: 800">This campaign is getting records from LMS Database and client list</div>
		</div>
	</div>
	<hr />
	<div class="row">
		<div class="col-12">
			<span class="form-check form-switch">
				<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_employee_size" (click)="criteriaSelected('employee_size')" />
				Employee Size
			</span>

			<span class="form-check form-switch">
				<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_asset_size"  (click)="criteriaSelected('asset_size')" />
				Asset Size

			</span>

			<span class="form-check form-switch">
				<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_plan_participants" (click)="criteriaSelected('plan_participants')" />
				Plan Participants
			</span>

			<span class="form-check form-switch">
				<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_state" (click)="criteriaSelected('state')" />
				State
			</span>

			<span class="form-check form-switch">
				<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_zip_code"  (click)="criteriaSelected('zip_code')" />
				Zip Code
			</span>
		</div>
	</div>
	<hr />
	<form [formGroup]="formCriteria">
		<div class="row" *ngIf="criterias.section_state">
			<div class="col-12">
				<h3 style="margin-top: 0px">State</h3>
				<div class="form-group row col-sm-12">
					<div class="col-sm-8">
						<select class="form-control money-green" formControlName="state" [class.is-invalid]="formCriteria.get('state').touched && formCriteria.get('state').invalid" [class.is-valid]="formCriteria.get('state').touched && formCriteria.get('state').valid">
							<option value="">Select a State</option>
							<option value="{{ state.shortName }}" *ngFor="let state of states">
								{{ state.shortName }} - {{ state.name }}
							</option>
						</select>
					</div>
					<div class="col-sm-4">
						<button class="btn btn-primary" (click)="saveCriteriaState()">Save</button>
					</div>
				</div>

				<br />

				<table class="table">
					<thead>
						<tr>
							<th>State</th>
							<th>Remove</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let state of rowsStates">
							<td>{{state.state}} - {{getStateName(state.state)}}</td>
							<td><button class="btn btn-danger btn-xsm button-space" (click)="removeState(state.state)" style="display: inline-block"><i class="ri-delete-bin-5-line"></i></button></td>
						</tr>
					</tbody>
				</table>

			</div>
		</div>
		<hr *ngIf="criterias.section_state">
		<div class="row">
			<div class="col-6" *ngIf="criterias.section_zip_code">
				<h3 style="margin-top: 0px">Zip Codes</h3>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-map-pin-fill"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Zip Code" formControlName="zip_code" [class.is-invalid]="formCriteria.get('zip_code').touched && formCriteria.get('zip_code').invalid" [class.is-valid]="formCriteria.get('zip_code').touched && formCriteria.get('zip_code').valid" />
				</div>
			</div>
			<div class="col-6" *ngIf="criterias.section_zip_code">
				<h3 style="margin-top: 0px">Radius</h3>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-gradienter-line"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Radius in Miles" formControlName="radius" [class.is-invalid]="formCriteria.get('radius').touched && formCriteria.get('radius').invalid" [class.is-valid]="formCriteria.get('radius').touched && formCriteria.get('radius').valid" />
				</div>
			</div>
		</div>
		<hr *ngIf="criterias.section_zip_code" />
		<div class="row" *ngIf="criterias.section_employee_size">
			<div class="col-12">
				<h3 style="margin-top: 0px">
					Employee Size
					<span style="font-size: 15px" class="selectors" (click)="limitSelected('employee_size')">
						Add Limit
						<i
							class="fa fa-square-o"
							aria-hidden="true"
							[ngClass]="{
								'fa-square-o': !criteriasLimits.employee_size,
								'fa-check-square-o': criteriasLimits.employee_size
							}"
						></i>
					</span>
				</h3>
			</div>
		</div>
		<div class="row" *ngIf="criterias.section_employee_size">
			<div class="col-6">
				<label class="form-label">Minimum *</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-group-2-fill"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Employee Size Min" formControlName="employee_size_min" [class.is-invalid]="formCriteria.get('employee_size_min').touched && formCriteria.get('employee_size_min').invalid" [class.is-valid]="formCriteria.get('employee_size_min').touched && formCriteria.get('employee_size_min').valid" />
				</div>
			</div>
			<div class="col-6" *ngIf="criteriasLimits.employee_size">
				<label class="form-label">Maximum *</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-group-2-fill"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Employee Size Max" formControlName="employee_size_max" [class.is-invalid]="formCriteria.get('employee_size_max').touched && formCriteria.get('employee_size_max').invalid" [class.is-valid]="formCriteria.get('employee_size_max').touched && formCriteria.get('employee_size_max').valid" />
				</div>
			</div>
		</div>
		<hr *ngIf="criterias.section_employee_size" />

		<div class="row" *ngIf="criterias.section_asset_size">
			<div class="col-12">
				<h3 style="margin-top: 0px">
					Asset Size
					<span style="font-size: 15px" class="selectors" (click)="limitSelected('asset_size')">
						Add Limit
						<i
							class="fa fa-square-o"
							aria-hidden="true"
							[ngClass]="{
								'fa-square-o': !criteriasLimits.asset_size,
								'fa-check-square-o': criteriasLimits.asset_size
							}"
						></i>
					</span>
				</h3>
			</div>
		</div>
		<div class="row" *ngIf="criterias.section_asset_size">
			<div class="col-6">
				<label class="form-label">Minimum *</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-money-dollar-box-fill"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Asset Size Min" formControlName="asset_size_min" [class.is-invalid]="formCriteria.get('asset_size_min').touched && formCriteria.get('asset_size_min').invalid" [class.is-valid]="formCriteria.get('asset_size_min').touched && formCriteria.get('asset_size_min').valid" />
				</div>
			</div>
			<div class="col-6" *ngIf="criteriasLimits.asset_size">
				<label class="form-label">Maximum *</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-money-dollar-box-fill"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Assets Size Max" formControlName="asset_size_max" [class.is-invalid]="formCriteria.get('asset_size_max').touched && formCriteria.get('asset_size_max').invalid" [class.is-valid]="formCriteria.get('asset_size_max').touched && formCriteria.get('asset_size_max').valid" />
				</div>
			</div>
		</div>
		<hr *ngIf="criterias.section_asset_size" />

		<div class="row" *ngIf="criterias.section_plan_participants">
			<div class="col-12">
				<h3 style="margin-top: 0px">
					Plan Participants
					<span style="font-size: 15px" class="selectors" (click)="limitSelected('plan_participants')">
						Add Limit
						<i
							class="fa fa-square-o"
							aria-hidden="true"
							[ngClass]="{
								'fa-square-o': !criteriasLimits.plan_participants,
								'fa-check-square-o': criteriasLimits.plan_participants
							}"
						></i>
					</span>
				</h3>
			</div>
		</div>
		<div class="row" *ngIf="criterias.section_plan_participants">
			<div class="col-6">
				<label class="form-label">Minimun *</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-pie-chart-2-fill"></i></span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Plan Participants Min" formControlName="plan_participants_min" [class.is-invalid]="formCriteria.get('plan_participants_min').touched && formCriteria.get('plan_participants_min').invalid" [class.is-valid]="formCriteria.get('plan_participants_min').touched && formCriteria.get('plan_participants_min').valid" />
				</div>
			</div>
			<div class="col-6" *ngIf="criteriasLimits.plan_participants">
				<label class="form-label">Maximum *</label>
				<div class="input-group mb-3">
					<div class="input-group-prepend">
						<span class="input-group-text"><i class="ri-pie-chart-2-fill"></i> </span>
					</div>
					<input type="number" class="form-control money-green" placeholder="Plan Participants Max" formControlName="plan_participants_max" [class.is-invalid]="formCriteria.get('plan_participants_max').touched && formCriteria.get('plan_participants_max').invalid" [class.is-valid]="formCriteria.get('plan_participants_max').touched && formCriteria.get('plan_participants_max').valid" />
				</div>
			</div>
		</div>
	</form>
	<hr *ngIf="criterias.section_plan_participants" />
	<div class="row">
		<div class="col-12" align="right">
			<button class="btn btn-success" (click)="saveCriterias()"><i class="fa fa-save"></i> Save</button>
		</div>
	</div>
</div>
